import { TApiAction, TApiDataStateSlice } from "@redux/store.types";

const defaultReducer = (
    state: TApiDataStateSlice,
    action: TApiAction,
    constants: any,
    options: any,
    initialState: any,
) => {
    const { type, payload, actionOptions = {} } = action;

    if (type === constants.RESET) {
        return { ...initialState };
    }

    if (type === constants.PENDING) {
        return {
            ...state,
            params: payload,
            error: null,
            data: options.clearOnFetch ? null : state.data,
        };
    }

    const skipSuccessData = actionOptions?.skipSuccessData
        ? actionOptions.skipSuccessData()
        : false;

    if (type === constants.SUCCESS) {
        return {
            ...state,
            error: null,
            data: skipSuccessData ? state.data : payload,
        };
    }

    if (type === constants.FAILURE) {
        return {
            ...state,
            error: payload,
            data: options.clearOnError ? null : state.data,
        };
    }

    return state;
};

export default defaultReducer;
